import { StateManager } from './statemanager';
import { State } from './state';

export class EmptyState extends State {
    constructor() {
        super();
    }

    async prepare(): Promise<void> {
        // No preparation needed for empty state
    }

    enter() {
    }

    leave() {
    }

    update(delta: any) {
    }
}

StateManager.register('empty', EmptyState);

